import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=6405dede&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=6405dede&prod&lang=scss&scoped=true"
import style1 from "./ChatBox.vue?vue&type=style&index=1&id=6405dede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405dede",
  null
  
)

export default component.exports